/**
 * PDP image loupe (desktop only) — spec: specs/worklists/site-speed-phase-3.md #6.
 *
 * Each loupe initialises on the first mouseenter over its image instead of at page
 * load: the previous version preloaded the 2800px version of every gallery image
 * up front (39 images ≈ 24.5 MB on a PDP). Markup comes from snippets/media.liquid
 * (.js-loupe > .js-loupe-element + .js-loupe-image[data-image-full]).
 */
(function () {
  'use strict';

  const DESKTOP_QUERY = '(min-width: 750px)';
  const MIN_ZOOM = 0.5;
  const MAX_ZOOM = 1.5;
  const ZOOM_STEP = 0.1;

  if (!window.matchMedia(DESKTOP_QUERY).matches) return;

  function roundToPlace(number, place) {
    return Math.round(number * Math.pow(10, place)) / Math.pow(10, place);
  }

  function initLoupe(loupe) {
    const image = loupe.querySelector('.js-loupe-image');
    const loupeElement = loupe.querySelector('.js-loupe-element');
    if (!image || !loupeElement) return;

    const imageFullUrl = image.getAttribute('data-image-full');
    const loupeSize = [loupeElement.offsetWidth, loupeElement.offsetHeight];
    let fullImageSize = [0, 0];
    let zoomLevel = 1;

    loupeElement.style.backgroundImage = 'url(' + imageFullUrl + ')';

    const fullImage = new Image();
    fullImage.onload = function () {
      fullImageSize = [fullImage.width, fullImage.height];
    };
    fullImage.src = imageFullUrl;

    loupe.addEventListener('mousemove', function (event) {
      const positionRatio = [
        roundToPlace(event.offsetX / image.offsetWidth, 3),
        roundToPlace(event.offsetY / image.offsetHeight, 3),
      ];
      const offset = [
        loupeSize[0] * positionRatio[0] - loupeSize[0] / 2,
        loupeSize[1] * positionRatio[1] - loupeSize[1] / 2,
      ];

      loupeElement.style.backgroundPosition =
        'calc(' + positionRatio[0] * 100 + '% - ' + offset[0] + 'px) ' +
        'calc(' + positionRatio[1] * 100 + '% - ' + offset[1] + 'px)';
      loupeElement.style.top = event.offsetY + 'px';
      loupeElement.style.left = event.offsetX + 'px';
    });

    loupe.addEventListener('wheel', function (event) {
      event.preventDefault();
      if (event.deltaY < 0 && zoomLevel < MAX_ZOOM) {
        zoomLevel += ZOOM_STEP;
      } else if (event.deltaY > 0 && zoomLevel > MIN_ZOOM) {
        zoomLevel -= ZOOM_STEP;
      } else {
        return;
      }
      loupeElement.style.backgroundSize =
        fullImageSize[0] * zoomLevel + 'px ' + fullImageSize[1] * zoomLevel + 'px';
    }, { passive: false });
  }

  document.querySelectorAll('.js-loupe').forEach(function (loupe) {
    loupe.addEventListener('mouseenter', function () {
      initLoupe(loupe);
    }, { once: true });
  });
})();
